import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { getTransactionResult } from "../../Actions/Actions";
import ModalResult from "../../Components/ModalResult";
import "./styles.css";
import {axios} from "../../Actions/CommonActions";
import Api from "../../Constants/Api";
import {toast} from "react-toastify";

const Loading = () => {
  const [modalResult, setModalResult] = useState(false);
  const [detail, setDetail] = useState({});
  const history = useHistory();

  useEffect(() => {
    getTransactionId();
  }, []);

  const getTransactionId = () => {
    const url_string = window.location.href;
    const url = new URL(url_string);
    const transactionId = url.searchParams.get("transaction_id");
    const token = url.searchParams.get("token");
    const businessId = url.searchParams.get("business_id");
    if (businessId) {
      return history.push({
        pathname: "/daapapp-softpos/payment-info",
        state: { business_id: businessId },
      });
    }
    if (transactionId) {
      const accessToken = sessionStorage.getItem("Access_Token");

      if (token) {
        axios
            .get(`https://api.daapapp.com/api/v1/agency/gateway/service/auth/check?token=${token}&transaction_id=${transactionId}`)
            .then((response) => {
              const { access_token, token_type,payment_options_data } = response?.data?.data || {};
              const acceessToken = `${token_type} ${access_token}`;
              sessionStorage.setItem("Access_Token", access_token);

              if (acceessToken) {
                if (payment_options_data.show_payment_options){
                  getTransactionResult(transactionId)
                      .then((result) => {
                        if (result?.redirect === "payment_gateway") {
                          history.push({
                            pathname: "/payment",
                            state: { result, transactionId },
                          });
                        } else if (result?.redirect === "payment_gateway_callback") {
                          history.push({
                            pathname: "/result",
                            state: result,
                          });
                        } else {
                          setDetail({
                            status: "failed",
                            title: "خطا",
                            body: "درگاه پرداخت با مشکل مواجه شد",
                            dismissible: true,
                          });
                          setModalResult(true);
                        }
                      })
                      .catch((err) => {
                        if (err?.status === 401) {
                          history.push({
                            pathname: "/sign-in",
                            state: transactionId,
                          });
                        } else {
                          setDetail({
                            status: "failed",
                            title: "خطا",
                            body: err?.data?.message,
                            dismissible: true,
                          });
                          setModalResult(true);
                        }
                      });
                } else {
                  axios({
                    method: "POST",
                    baseURL: Api.PUBLIC_API_V2,
                    url: "daap/wallets/payment",
                    data: payment_options_data.payment_data.payload,
                  })
                      .then((res) => {
                        const link = res.data.data.redirect_url;
                        window.location.href = link;
                      })
                }

              } else {
                history.push({
                  pathname: "/sign-in",
                  state: transactionId,
                });
              }
            });
      }else if (accessToken) {
        getTransactionResult(transactionId)
            .then((result) => {
              if (result?.redirect === "payment_gateway") {
                history.push({
                  pathname: "/payment",
                  state: { result, transactionId },
                });
              } else if (result?.redirect === "payment_gateway_callback") {
                if (result.direct_payment_gateway_id) {
                  axios({
                    baseURL:Api.AGENCY_API,
                    url: `/gateway/direct/verify/${transactionId}`,
                    method: "GET",
                  })
                      .then(() => {
                        history.push({
                          pathname: "/transaction-status",
                          state: {result: {...result.direct_payment_gateway_items,status:true}},
                        });
                      })
                      .catch((err) => {
                        toast(err.response.data.message, { type: "error" });
                      });
                }
                history.push({
                  pathname: "/result",
                  state: result,
                });
              } else {
                if (result.direct_payment_gateway_id) {
                  history.push({
                    pathname: "/transaction-status",
                    state: {result: {...result.direct_payment_gateway_items,status:false}},
                  });
                }else if (result?.gateway_callback){
                  window.open(result.gateway_callback, "_self");
                }else {
                  setDetail({
                    status: "failed",
                    title: "خطا",
                    body: "درگاه پرداخت با مشکل مواجه شد",
                    dismissible: true,
                  });
                  setModalResult(true);
                }
              }
            })
            .catch((err) => {
              if (err?.status === 401) {
                history.push({
                  pathname: "/sign-in",
                  state: transactionId,
                });
              } else {
                setDetail({
                  status: "failed",
                  title: "خطا",
                  body: err?.data?.message || "خطای نامشخص",
                  dismissible: true,
                });
                setModalResult(true);
              }
            });
        return;
      }else {
        history.push({
          pathname: "/sign-in",
          state: transactionId,
        });
      }
    } else {
      setDetail({
        status: "failed",
        title: "خطا",
        body: "درگاه پرداخت یافت نشد",
        dismissible: true,
      });
      setModalResult(true);
    }
  };

  return (
    <div className="app-loading">
      <p>در حال بارگذاری اطلاعات</p>
      <Spinner
        as="span"
        animation="border"
        size="lg"
        role="status"
        aria-hidden="true"
      />
      <ModalResult
        show={modalResult}
        onClose={() => setModalResult(false)}
        result={detail}
      />
    </div>
  );
};
export default Loading;
